import { render, staticRenderFns } from "./ChgPwd.vue?vue&type=template&id=63f0726e&"
import script from "./ChgPwd.vue?vue&type=script&lang=js&"
export * from "./ChgPwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/iy_web_test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63f0726e')) {
      api.createRecord('63f0726e', component.options)
    } else {
      api.reload('63f0726e', component.options)
    }
    module.hot.accept("./ChgPwd.vue?vue&type=template&id=63f0726e&", function () {
      api.rerender('63f0726e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/User/forms/ChgPwd.vue"
export default component.exports